import React from 'react';

const WazinWatermark = ({ opacity = 0.08, size = 'large', position = 'center' }) => {
  // Size configurations
  const sizeClasses = {
    small: 'w-[400px] md:w-[500px]',
    medium: 'w-[500px] md:w-[700px]',
    large: 'w-[600px] md:w-[900px] lg:w-[1100px]',
    xlarge: 'w-[700px] md:w-[1000px] lg:w-[1300px]'
  };

  // Position configurations
  const positions = {
    center: 'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2',
    'center-right': 'top-1/2 right-0 translate-x-1/4 -translate-y-1/2',
    'center-left': 'top-1/2 left-0 -translate-x-1/4 -translate-y-1/2',
    'bottom-right': 'bottom-10 right-0 translate-x-1/4'
  };

  return (
    <div 
      className="fixed inset-0 pointer-events-none overflow-hidden"
      style={{ zIndex: 0 }}
    >
      {/* Main Logo Watermark - Gray Tone */}
      <div className={`absolute ${positions[position]} transform`}>
        <img 
          src="/images/wazin-logo.png" 
          alt="Wazin Watermark" 
          className={`${sizeClasses[size]} h-auto object-contain select-none`}
          style={{ 
            opacity: opacity,
            filter: 'grayscale(100%) brightness(85%)',
            mixBlendMode: 'multiply'
          }}
        />
      </div>
    </div>
  );
};

export default WazinWatermark;
